import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 3C9.06696 3 6.46382 4.41965 4.81934 6.6H4.8V6.62461C3.67496 8.12702 3 9.98435 3 12C3 16.9599 7.0401 21 12 21C16.9599 21 21 16.9599 21 12C21 7.0401 16.9599 3 12 3ZM14.7 5.32559C17.3416 6.39062 19.2 8.96938 19.2 12C19.2 13.879 18.4805 15.5805 17.3086 16.8604C17.0783 16.1316 16.4051 15.6 15.6 15.6H14.7V12.9C14.7 12.4032 14.2968 12 13.8 12H9.3V10.2H10.2C10.6968 10.2 11.1 9.7968 11.1 9.3V7.5H12.9C13.8945 7.5 14.7 6.6945 14.7 5.7V5.32559ZM4.98633 10.3863L6.6 12L9.3 14.7V15.6C9.3 16.5945 10.1055 17.4 11.1 17.4V19.1385C7.54119 18.697 4.8 15.6816 4.8 12C4.8 11.444 4.86797 10.9056 4.98633 10.3863Z",
		fill: "currentColor"
	})
});
export default SvgGlobe;
